import { render, staticRenderFns } from "./ShopsTable.vue?vue&type=template&id=d7f49e9a&scoped=true"
import script from "./ShopsTable.vue?vue&type=script&lang=js"
export * from "./ShopsTable.vue?vue&type=script&lang=js"
import style0 from "./ShopsTable.vue?vue&type=style&index=0&id=d7f49e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f49e9a",
  null
  
)

export default component.exports